import { t } from '@lingui/macro'
import { FormInput, SearchIcon } from 'pages/native/onBoarding/components'
import React, { ChangeEvent, FC } from 'react'
import styles from './SearchInput.module.scss'

interface SearchInputProps {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const SearchInput: FC<SearchInputProps> = ({ value, onChange }) => {
  return (
    <div className={styles.SearchInputContainer}>
      <FormInput
        id="searchInput"
        name="searchInput"
        label=""
        placeholder={t`Search for teams...`}
        type="text"
        value={value}
        isValid={true}
        onChange={onChange}
        leadingIcon={<SearchIcon />}
      />
    </div>
  )
}
